import React, { useEffect, useState } from "react";
import API from "../services/api";
import { formatDateTimeDMY } from "../utils/dateFormat";

function Devices() {
  const [devices, setDevices] = useState([]);
  const [machines, setMachines] = useState([]);
  const [name, setName] = useState("");
  const [machineId, setMachineId] = useState("");
  const [generatedToken, setGeneratedToken] = useState("");

  const loadAll = async () => {
    const [d, m] = await Promise.all([API.get("/devices"), API.get("/machines")]);
    setDevices(d.data);
    setMachines(m.data);
  };

  useEffect(() => {
    loadAll();
  }, []);

  const createDevice = async () => {
    if (!name.trim()) {
      alert("Debes ingresar nombre");
      return;
    }
    const res = await API.post("/devices", {
      name: name.trim(),
      machine_id: machineId ? parseInt(machineId, 10) : null
    });
    setGeneratedToken(res.data.token || "");
    setName("");
    setMachineId("");
    await loadAll();
  };

  const rotateToken = async id => {
    if (!window.confirm("¿Rotar token de este dispositivo?")) return;
    const res = await API.post(`/devices/${id}/rotate-token`);
    setGeneratedToken(res.data.token || "");
    await loadAll();
  };

  const updateDevice = async (d, changes) => {
    await API.put(`/devices/${d.id}`, {
      name: changes.name ?? d.name,
      machine_id: changes.machine_id !== undefined ? changes.machine_id : d.machine_id,
      active: changes.active !== undefined ? changes.active : d.active
    });
    await loadAll();
  };

  const formatDate = value => {
    if (!value) return "Nunca";
    return formatDateTimeDMY(value);
  };

  return (
    <div>
      <header className="page-header">
        <h1 className="page-title">Dispositivos</h1>
        <p className="page-subtitle">
          Terminales Android, asignación a máquinas y rotación de tokens.
        </p>
      </header>

      <div className="card card--padded" style={{ marginBottom: "1.25rem" }}>
        <h2 className="section-title">Crear dispositivo</h2>
        <div className="field-row">
          <input
            className="input"
            placeholder="Nombre del dispositivo"
            value={name}
            onChange={e => setName(e.target.value)}
            style={{ minWidth: "200px" }}
          />
          <select
            className="select"
            value={machineId}
            onChange={e => setMachineId(e.target.value)}
          >
            <option value="">Sin máquina asignada</option>
            {machines.map(m => (
              <option key={m.id} value={m.id}>
                {m.name}
              </option>
            ))}
          </select>
          <button type="button" className="btn btn-primary" onClick={createDevice}>
            Crear
          </button>
        </div>
      </div>

      {generatedToken && (
        <div className="alert alert--warning" style={{ marginBottom: "1.25rem" }}>
          <strong>Token generado (mostrar solo una vez)</strong>
          <div className="token-box">{generatedToken}</div>
        </div>
      )}

      <div className="table-wrap">
        <table className="table-modern">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nombre</th>
              <th>Máquina</th>
              <th>Estado</th>
              <th>Última conexión</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {devices.map(d => (
              <tr key={d.id}>
                <td>{d.id}</td>
                <td>
                  <input
                    className="input"
                    defaultValue={d.name}
                    onBlur={e => {
                      if (e.target.value.trim() !== d.name) {
                        updateDevice(d, { name: e.target.value.trim() });
                      }
                    }}
                  />
                </td>
                <td>
                  <select
                    className="select"
                    value={d.machine_id || ""}
                    onChange={e =>
                      updateDevice(d, {
                        machine_id: e.target.value ? parseInt(e.target.value, 10) : null
                      })
                    }
                  >
                    <option value="">Sin asignar</option>
                    {machines.map(m => (
                      <option key={m.id} value={m.id}>
                        {m.name}
                      </option>
                    ))}
                  </select>
                  <div style={{ fontSize: "0.75rem", color: "var(--color-text-muted)", marginTop: "4px" }}>
                    {d.machine_name || ""}
                  </div>
                </td>
                <td>{d.active ? "Activo" : "Inactivo"}</td>
                <td style={{ whiteSpace: "nowrap" }}>{formatDate(d.last_seen_at)}</td>
                <td>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => updateDevice(d, { active: !d.active })}
                  >
                    {d.active ? "Desactivar" : "Activar"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ marginLeft: "8px" }}
                    onClick={() => rotateToken(d.id)}
                  >
                    Rotar token
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Devices;
